export function BrandLogo({
  size = "lg",
  onClick,
}: {
  size?: "lg" | "sm";
  onClick?: () => void;
}) {
  const inner = (
    <>
      <img className="sg-logo__tile" src="./sign-tile.png" alt="" draggable={false} />
      <span className="sg-logo__text">
        <strong>Aurélia</strong>
        <em>Signature</em>
      </span>
    </>
  );
  if (onClick) {
    return (
      <button type="button" className={`sg-logo is-${size}`} onClick={onClick}>
        {inner}
      </button>
    );
  }
  return <div className={`sg-logo is-${size}`}>{inner}</div>;
}
